import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { IApiToken } from '../ServerApi/types/IApiToken';
import { ServerService } from '../services/ServerService';

export interface IScimSettingsCtrlScope extends ng.IScope {
  secret: string;
  baseUrl: string;
  scimProvisioningEnabled: boolean;

  initScimApiToken: () => void;
  createScimApiToken: () => void;
  deleteScimApiToken: () => void;
  toggleScimProvisioning: () => void;
  selectAll: (event: any) => void;
  openSCIMHelp: () => void;
}

const SCIM_CLIENT_API_TOKEN = 'SCIM_CLIENT_API_TOKEN';

export class ScimSettingsCtrl {

  public static $inject = [
    '$q',
    '$scope',
    '$window',
    'ServerService'
  ];

  constructor(
    $q: ng.IQService,
    $scope: IScimSettingsCtrlScope,
    $window: ng.IWindowService,
    server: ServerService
  ) {
    const getBaseUrl = (scimEnabled: boolean) => {
      if (!scimEnabled) {
        return 'https://';
      }
      //TODO: This is just a hack to get the pod name. It should be replaced with the actual pod name.
      // Or get removed after SCIM starts using MIDS.
      const podName = window.location.hostname === 'localhost' ?
          'local-pod-fake' : window.location.hostname.split('.')[0];
      return 'https://scim.online.tableau.com/pods/' + podName +
          '/sites/' + server.sessionSiteLuid() + '/scim/v2';
    };

    $scope.selectAll = (event: any) => {
       event.target.select();
    };

    $scope.openSCIMHelp = () => {
      $window.open('https://onlinehelp.tableau.com/current/online/en-us/scim_config_online.htm', '_blank');
    };

    $scope.initScimApiToken = () => {
      server.getApiTokens().then((allApiTokens: IApiToken[]) => {
        const scimApiTokens: IApiToken[] = allApiTokens.
            filter(token => token.clientName === SCIM_CLIENT_API_TOKEN);
        $scope.scimProvisioningEnabled = (scimApiTokens.length > 0);
        $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
      });
    };

    $scope.createScimApiToken = () => {
      server.createApiToken(SCIM_CLIENT_API_TOKEN).then((newApiToken: IApiToken) => {
        $scope.scimProvisioningEnabled = true;
        $scope.secret = newApiToken.secret;
        $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
      });
    };

    $scope.deleteScimApiToken = () => {
      server.getApiTokens().then((allApiTokens: IApiToken[]) => $q.all(
        allApiTokens.filter(token => token.clientName === SCIM_CLIENT_API_TOKEN).
            map(token => server.deleteApiToken(token.id))).then(() => {
        $scope.scimProvisioningEnabled = false;
        $scope.secret = null;
        $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
      }));
    };

    $scope.toggleScimProvisioning = () => {
      if ($scope.scimProvisioningEnabled) {
        $scope.deleteScimApiToken();
      } else {
        $scope.createScimApiToken();
      }
    };

    $scope.scimProvisioningEnabled = false;
    $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
    $scope.secret = null;
    // Make a call to /getApiTokens to initialize the variables
    if (FeatureFlags.scimApiTokenEnabled) {
      $scope.initScimApiToken();
    }
  }
}

Module.instance().controller('ScimSettingsCtrl', ScimSettingsCtrl);
